import { render } from "./DialogCompleteReservationCancel.vue?vue&type=template&id=20285a1f"
import script from "./DialogCompleteReservationCancel.vue?vue&type=script&lang=js"
export * from "./DialogCompleteReservationCancel.vue?vue&type=script&lang=js"
script.render = render

export default script